export const QUESTION_LIST_REQUEST = 'QUESTION_LIST_REQUEST';
export const QUESTION_LIST_SUCCESS = 'QUESTION_LIST_SUCCESS';
export const QUESTION_LIST_FAIL = 'QUESTION_LIST_FAIL';
